// extracted by mini-css-extract-plugin
export default {"container":"ChallengeJoinButton--container--YOfHh","button":"ChallengeJoinButton--button--Q7s71"};